import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _class, _descriptor, _descriptor2, _descriptor3, _AbActionMenuItem;
/*
 *                     NOTICE
 *            COPYRIGHT 2019 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { LogUtils } from "abweb/utils/log/LogUtils";
import { action, observable, makeObservable } from "mobx";

/**
 * Representation of an item appearing in the action menu. An action menu item is represented by an icon, a label
 * and a callback function. The label is used as a tooltip (title) if only an icon is displayed.
 */
export let AbActionMenuItem = (_class = (_AbActionMenuItem = class AbActionMenuItem {
  constructor(icon, label, callback, enabled = true, shortcut = null, dataTestId, tooltip = "") {
    _initializerDefineProperty(this, "icon", _descriptor, this);
    _initializerDefineProperty(this, "enabled", _descriptor2, this);
    _defineProperty(this, "_callback", void 0);
    _defineProperty(this, "_label", void 0);
    _defineProperty(this, "_shortcut", void 0);
    _initializerDefineProperty(this, "_disabledReasons", _descriptor3, this);
    this.dataTestId = dataTestId;
    makeObservable(this);
    this._disabledReasons = undefined;
    if (tooltip) {
      this._disabledReasons = [tooltip];
    }
    if (icon === null) {
      icon = "absdk:transparent";
    }
    this.icon = icon;
    this._label = label;
    this._callback = callback;
    this.log(`constructor: enabled = ${enabled}`);
    this.enabled = enabled;
    this._shortcut = shortcut;
  }
  get disabledReasons() {
    return this._disabledReasons;
  }
  setDisabledReasons(reasons) {
    this._disabledReasons = reasons;
  }
  get shortcut() {
    return this._shortcut;
  }
  get label() {
    return this._label;
  }
  get callback() {
    return this._callback;
  }
  initializeAndWait() {
    return Promise.resolve();
  }
  log(s) {
    // AbActionMenuItem.LOGGER.debug(`*** ${this.label}: ${s}`);
  }
}, _defineProperty(_AbActionMenuItem, "LOGGER", LogUtils.getLogger(__filename)), _AbActionMenuItem), _descriptor = _applyDecoratedDescriptor(_class.prototype, "icon", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "enabled", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_disabledReasons", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "setDisabledReasons", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setDisabledReasons"), _class.prototype), _class);
//# sourceMappingURL=AbActionMenuItem.js.map
